import { useSmsPreview } from '#/shared/lib/sms-preview'
import type { SmsDeliverability } from '#/shared/lib/sms-preview'

import type { ThreadMainline } from './conversation'
import { useActiveLine } from './use-phone-numbers'

interface ComposerDeliverabilityArgs {
  /** The draft as it would go on the wire (already flattened and sanitized). */
  body: string
  /** Set on a thread that sends from a shared mainline. */
  mainline?: ThreadMainline
  /** The counterparty — without it the recipient-side gates can't be checked. */
  toNumber?: string
  enabled?: boolean
}

/**
 * The server's pre-send read on the conversation draft: content findings that
 * invite a carrier spam block, plus the hard blockers that stop the send here.
 *
 * The line is resolved the same way the send does — a thread on a shared
 * mainline goes out on that line, otherwise on the caller's active line — so
 * the sender-scoped checks (line SMS-capable, consent for this route) grade the
 * line the message will actually leave from.
 */
export function useComposerDeliverability({
  body,
  mainline,
  toNumber,
  enabled = true,
}: ComposerDeliverabilityArgs): SmsDeliverability {
  const { active: line } = useActiveLine()
  return useSmsPreview({
    body,
    userPhoneId: mainline?.id ?? line?.id,
    toNumber,
    enabled,
  })
}
